export default require('./TabShare').default
